import { TriggerLogEntityModel } from "src/store/models/entity/triggerLog/entity";
import { TriggerLogHelperModel } from "src/store/models/entity/triggerLog/helper";

export const encooTriggerLogModels = {
  entity: TriggerLogEntityModel,
  helper: TriggerLogHelperModel,
};
